import { useEffect, useMemo, useState } from 'react';
import { getUpgradeManager, UPGRADE_DEFS } from '@/game/upgrades';

export function useUpgrades() {
  const manager = useMemo(() => getUpgradeManager(), []);
  const [state, setState] = useState(() => manager.getState());

  useEffect(() => {
    return manager.onUpdate(() => setState(manager.getState()));
  }, [manager]);

  return {
    defs: UPGRADE_DEFS,
    manager,
    state,
  };
}

